import { CompanyResponseDto } from '@planning/app/api'
import { EntityItem } from '../base/EntityItem'
import { IEntity } from '../types'

export type ICompanyItem = IEntity<CompanyResponseDto>

export class CompanyItem extends EntityItem<CompanyResponseDto> implements ICompanyItem {}
